import { ViteReactSSG } from "vite-react-ssg"

import { routes } from "@/routes"
import "@/styles/globals.css"

/**
 * Entry point.
 *
 * `ViteReactSSG` is the vite-react-ssg replacement for `createRoot()` —
 * during dev it acts as a normal client-side router; during build it
 * walks the route tree and renders each route to static HTML.
 *
 * The setup callback is for side effects (e.g. analytics init), NOT for
 * wrapping the app in providers — providers belong in the route layout
 * (see RootLayout). This keeps the prerender pipeline simple.
 */
export const createRoot = ViteReactSSG({ routes })
